import React from "react";

type HeaderShellProps = {
  mode: "full" | "stacked" | "compact";
  className?: string;
  style?: React.CSSProperties;
  primaryRow: React.ReactNode;
  primaryRowClassName?: string;
  secondaryRow?: React.ReactNode;
  showSecondaryRow?: boolean;
};

export const HeaderShell = ({
  mode,
  className = "",
  style,
  primaryRow,
  primaryRowClassName = "flex w-full min-w-0 flex-col items-stretch gap-3 xl:flex-row xl:items-center xl:justify-between",
  secondaryRow,
  showSecondaryRow = false,
}: HeaderShellProps) => (
  <header className={className} style={style} data-toolbar-mode={mode}>
    <div className={primaryRowClassName}>{primaryRow}</div>
    {showSecondaryRow ? secondaryRow : null}
  </header>
);
